import { omit } from 'lodash'
import { parse, stringify } from 'querystringify'

// Types
import { Loop, Track } from 'types'

/* LOCAL STORAGE STUFF */
export const safeLocalStorageSetItem = (key: string, item: string): void => {
  let storageAccessible = false
  try {
    localStorage.setItem('testkey', 'testvalue')
    localStorage.removeItem('testkey')
    storageAccessible = true
  } catch (e) {
    storageAccessible = false
  }
  if (storageAccessible) {
    localStorage.setItem(key, item)
  }
}

export const safeLocalStorageGetItem = (key: string): string => {
  if (typeof Storage !== 'undefined') {
    try {
      return localStorage.getItem(key) || ''
    } catch (e) {
      return ''
    }
  }
  return ''
}

export const safeLocalStorageRemoveItem = (key: string): string => {
  if (typeof Storage !== 'undefined') {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      return ''
    }
  }
  return ''
}

export const safeLocalStorage = {
  getItem: safeLocalStorageGetItem,
  setItem: safeLocalStorageSetItem,
  removeItem: safeLocalStorageRemoveItem,
}

export const playlistNameFromQueryString = (queryString: string): string => {
  const query = parse(queryString)
  const purgedQuery = omit(query, ['page', 'size'])
  const purgedQueryString = stringify(purgedQuery)
  return purgedQueryString
}

/* Cleanse Html */
export const cleanseFromHtml = (string: string): string => string.replace(/<(?:.|\n)*?>(?:.|\n)*?>/g, '')

/* Parse duration */
export const parseDuration = (duration: string): { minutes: string; seconds: string; totalInSeconds: number } => {
  const [minutes, seconds] = duration.split(':')
  return {
    minutes,
    seconds,
    totalInSeconds: +minutes * 60 + +seconds,
  }
}

export const getLoopFromLocation = (search: string, track: Track): Loop | null | undefined => {
  const query = <{ [key: string]: string }>parse(search || '')
  if (!query || !query.shared_loop || !track) {
    return null
  }
  const loopParts = query.shared_loop.replace(/#.*$/, '').split(':')
  if (loopParts.length !== 5) {
    return null
  }
  const [trackId, time_start, time_end, beat_start, beat_count] = loopParts
  const trackDuration = track.length
  return +trackId === track.id
    ? {
        track_id: +trackId,
        time_start: Math.max(0, +time_start),
        time_end: Math.min(trackDuration, +time_end),
        beat_start: Math.max(0, +beat_start),
        beat_count: +beat_count,
      }
    : null
}

export const createSongItemId = (trackId: number, loop?: Loop | null | undefined): string =>
  `${trackId}${loop ? `-${String(loop.beat_start || '')}:${String(loop.beat_count || '')}` : ''}`

export const isJson = (str: string): boolean => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const getDocumentUrl = (id: (string | number) | null | undefined): string => {
  if (id) {
    return `/ds/${String(id)}/`
  }
  return ''
}
